var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{staticClass:"item",attrs:{"content":_vm.label,"effect":"light","placement":"bottom","enterable":false}},[_c('el-button',{class:`table-action-button table-action-button--${_vm.buttonColor}`,attrs:{"size":"small","icon":_vm.buttonIcon,"aria-label":_vm.label,"circle":"","disabled":_vm.disabled},on:{"click":_vm.clickFunction}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }